import React from "react";
import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import {
  SolutionOutlined,
  FileTextOutlined,
  TeamOutlined,
  MessageOutlined,
  FileDoneOutlined
} from "@ant-design/icons";
import { useUser } from "../../contexts/UserContext";
import { canAccessMenu } from "../../utils/permissions";

interface SidenavProps {
  color: string;
}

interface MenuConfig {
  key: string;
  path: string;
  label: string;
  icon: React.ReactNode;
}

const Sidenav: React.FC<SidenavProps> = ({ color }) => {
  const { pathname } = useLocation();
  const { user } = useUser();
  const page = pathname.replace("/", "");

  const menuConfig: MenuConfig[] = [
    {
      key: "jobs-management",
      path: "/jobs-management",
      label: "Quản lý việc làm",
      icon: <SolutionOutlined style={{ fontSize: 20, color }} />
    },
    {
      key: "job-submissions-management",
      path: "/job-submissions-management", 
      label: "Quản lý ứng tuyển",
      icon: <FileDoneOutlined style={{ fontSize: 20, color }} />
    },
    {
      key: "contacts-management",
      path: "/contacts-management",
      label: "Quản lý liên hệ",
      icon: <MessageOutlined style={{ fontSize: 20, color }} />
    },
    {
      key: "blogs-management",
      path: "/blogs-management",
      label: "Quản lý bài đăng", 
      icon: <FileTextOutlined style={{ fontSize: 20, color }} />
    },
    {
      key: "cultures-management",
      path: "/cultures-management",
      label: "Quản lý văn hoá", 
      icon: <FileTextOutlined style={{ fontSize: 20, color }} />
    },
    {
      key: "users-management",
      path: "/users-management",
      label: "Quản lý người dùng",
      icon: <TeamOutlined style={{ fontSize: 20, color }} />
    }
  ];

  const accessibleMenuItems = menuConfig.filter(item => 
    canAccessMenu(user?.role, item.key)
  );

  const menuItems = accessibleMenuItems.map((item, index) => ({
    key: (index + 1).toString(),
    label: (
      <NavLink to={item.path}>
        <span
          className="icon"
          style={{
            background: page === item.key ? color : "",
          }}
        >
          {item.icon}
        </span>
        <span className="label">{item.label}</span>
      </NavLink>
    ),
  }));

  return (
    <>
      <h1 className="logo logo-sm" style={{ textAlign: "center" }}>
        Nebecom
      </h1>
      <hr />
      <Menu theme="light" mode="inline" items={menuItems} />
    </>
  );
};

export default Sidenav;
